/* eslint-disable max-len */
import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { PAGE_OFFER, PAGE_THREATS } from '../../config/pages';

import Form from './common/Form';
import Footer from './common/Footer';

import ThreatsVideo from './threats/ThreatsVideo';
import ThreatsOne from './threats/ThreatsOne';
import ThreatsTwo from './threats/ThreatsTwo';
import ThreatsThree from './threats/ThreatsThree';
import ThreatsFour from './threats/ThreatsFour';
import ThreatsFive from './threats/ThreatsFive';

import OfferList from './offer/OfferList';
import OfferDetails from './offer/details/OfferDetails';
import SecurityOne from './security/SecurityOne';
import SecurityTwo from './security/SecurityTwo';
import SecurityThree from './security/SecurityThree';
import { companyInfoPropsType, getCmsOffer } from '../helpers/fetchCmsContent';
import ClientsSlider from './offer/ClientsSlider';

const Offer = ({
    t, openPage, language, page, breakpoint, pageTransitionState, consents, subpage, claim, companyInfo
}) => {
    const [offer, setOffer] = useState(null);

    const currentOffer = offer ? offer.items.find((item) => item.translations.slug === subpage) : null;

    useEffect(() => {
        const fetchOffer = async () => {
            const response = await getCmsOffer(language);
            setOffer(response);
        };
        fetchOffer();
    }, [language]);

    const threatsClassName = cx('container-threats-security-page', { open: page === PAGE_THREATS });
    const securityClassName = cx('container-threats-security-page', { open: page === PAGE_OFFER });

    return (
        <div className="container-threats-security" id="container-threats-security">
            <div className={ threatsClassName } id={ threatsClassName }>
                <ThreatsVideo t={ t } page={ page } videoId={ t('threats.video.link') }/>
                <ThreatsOne t={ t } language={ language } page={ page }/>
                <Form type="minimize" typeButton="consultation" t={ t } language={ language } formName="threats-blue-1" breakpoint={ breakpoint } linkColor="blue-bg" consents={ consents }/>
                <ThreatsTwo t={ t } page={ page }/>
                <Form type="estimate" typeButton="consultation" t={ t } language={ language } formName="threats-blue-2" breakpoint={ breakpoint } linkColor="blue-bg" consents={ consents }/>
                <ThreatsThree t={ t } page={ page } openPage={ openPage } language={ language }/>
                <ThreatsFour t={ t } page={ page }/>
                <Form type="audit" typeButton="consultation" t={ t } language={ language } formName="threats-blue-5" breakpoint={ breakpoint } linkColor="blue-bg" consents={ consents }/>
                <ThreatsFive t={ t } page={ page } openPage={ openPage } language={ language }/>
                <Form type="bottom" typeButton="consultation" t={ t } language={ language } formName="threats-bottom" breakpoint={ breakpoint } consents={ consents }/>
                <Footer t={ t } openPage={ openPage } language={ language } claim={ claim } companyInfo={ companyInfo }/>
            </div>
            <div className={ securityClassName } id={ securityClassName }>
                {currentOffer ?
                    <OfferDetails t={ t } openPage={ openPage } language={ language } item={ currentOffer } companyInfo={ companyInfo } claim={ claim }/>
                :
                    <Fragment>
                        <ClientsSlider language={ language } t={ t }/>
                        {offer && <OfferList t={ t } openPage={ openPage } language={ language } page={ page } pageTransitionState={ pageTransitionState } offer={ offer }/>}
                        <SecurityOne t={ t } openPage={ openPage } language={ language } page={ page }/>
                        <SecurityTwo t={ t } page={ page }/>
                        <SecurityThree t={ t } openPage={ openPage } language={ language } page={ page }/>
                        <Form type="bottom" typeButton="offer" t={ t } language={ language } formName="security-bottom" breakpoint={ breakpoint } consents={ consents }/>
                        <Footer t={ t } openPage={ openPage } language={ language } claim={ claim } companyInfo={ companyInfo }/>
                    </Fragment>}
            </div>
        </div>
    );
};

Offer.defaultProps = {
    subpage: null,
    companyInfo: null
};

Offer.propTypes = {
    t: PropTypes.func.isRequired,
    openPage: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
    page: PropTypes.string.isRequired,
    breakpoint: PropTypes.string.isRequired,
    pageTransitionState: PropTypes.string.isRequired,
    consents: PropTypes.objectOf(Object).isRequired,
    subpage: PropTypes.string,
    claim: PropTypes.string.isRequired,
    companyInfo: companyInfoPropsType
};

export default Offer;



// WEBPACK FOOTER //
// ./src/components/content/Offer.jsx